/**
 * Employee Incident Register Mapper
 * Maps transport layer DTOs to domain models for incident registration
 */
import type {
  LC_RegisterEmployeeIncidentIn,
  LC_RegisterEmployeeIncidentOut,
  RegisterIncidentInput,
  RegisterIncidentResult,
} from '../types';

/**
 * Maps UI input to backend DTO
 */
export const mapRegisterIncidentInput = (
  input: RegisterIncidentInput,
): LC_RegisterEmployeeIncidentIn => ({
  incidentTypeId: input.incidentTypeId,
  locationId: input.locationId,
  eventId: input.eventId,
  checkInDate: input.checkInDate,
  checkInTime: input.checkInTime,
  comment: input.comment || null,
  companyId: input.companyId,
  employeeId: input.employeeId,
});

/**
 * Maps backend response to UI domain model
 */
export const mapRegisterIncidentOutput = (
  out: LC_RegisterEmployeeIncidentOut,
): RegisterIncidentResult => ({
  incidentId: out.incidentId,
  message: out.message,
});
